<template>
  <div class="OtpVerification">
    <div class="MobileVerification">
      <div class="flex mobile-verification-inner">
        <div class="left-image">
          <div class="head-section">
            <div class="main-head">Look Before You Invest</div>
            <div class="second-head">StockAnts is a marketplace for price Estimate</div>
          </div>
          <img src="../assets/images/Landing-page-img.jpeg" alt="Full Image" class="full-image" />
        </div>

        <div class="right-content">
          <div class="logos">
            <div style="position: relative; top: -10px">
              <div class="powered-by-txt">Powered by</div>
              <img :src="logo1" alt="StockAnts" class="logo" />
            </div>
            <div class="center-line"></div>
            <div v-if="currentEnvironment">
              <img :src="currentEnvironment.logo" :alt="currentEnvironment.utm_source" class="logo" :style="[currentEnvironment.width ? { width: currentEnvironment.width } : {}]" style="margin: 0 15px" />
            </div>
          </div>
          <div class="otp-image-container">
            <img :src="otpImage" alt="OTP Image" class="otp-image" />
          </div>
          <div class="top-margin-20 input-box-section">
            <div>
              <div class="top-margin-15" v-if="!is_otp_sent">
                <div class="input-group-section">
                  <div
                    class="form-group"
                    :class="{
                      'not-empty': mobile.length,
                      'form-group--error': showErrorOnEmpty && $v.mobile.$error,
                    }"
                  >
                    <div class="text-left">
                      <div class="bottom-margin-5 label-lg">One Time Mobile Verification</div>
                      <label class="input-label block bottom-margin-20">A four digit OTP will be sent via SMS on this number</label>
                    </div>
                    <div class="input-group-section">
                      <div
                        class="form-group"
                        :class="{
                          'not-empty': full_name.length,
                          'form-group--error': showErrorOnEmpty && $v.full_name.$error,
                        }"
                      >
                        <el-input type="text" class="form-control" placeholder="Enter your full name" name="full_name" v-model="full_name" @input="setFullName($event)" size="small"></el-input>
                      </div>
                      <div class="error" v-if="showErrorOnEmpty && !$v.full_name.required">Field is required</div>
                    </div>
                    <!-- <el-input type="phone" class="form-control" maxlength="10" placeholder="Enter your mobile number"
                      name="otp" v-model="mobile" @input="setMobile($event)" size="small"></el-input> -->

                    <!-- Mobile Number Input with Country Code -->
                    <el-input placeholder="Enter your mobile number" v-model="mobile" :maxlength="getMaxLength()" size="mini" @input="validateMobileNumber" style="width: 100%">
                      <!-- Dynamic Country Code Dropdown -->
                      <template slot="prepend">
                        <el-select 
  v-model="selectedCountryCode" 
  placeholder="Select" 
  size="mini" 
  style="width: 100px;" 
  filterable
  :popper-class="'dropdown-with-search'" 
  class="custom-select"
  @change="validateMobileNumber"
>
  <!-- Prefix slot to show selected country flag -->
  <template #prefix>
    <span v-if="selectedCountry">
      <img 
        :src="selectedCountry.flag" 
        alt="flag"
        style="width: 20px; height: 15px; margin-right: 5px; padding-top: 6px; vertical-align: middle;" 
      />
    </span>
  </template>

  <!-- Country dropdown options -->
  <el-option 
    v-for="country in countryCodes" 
    :key="`${country.country_code}-${country.name}`" 
    :label="`${country.country_code}`" 
    :value="country.country_code"
  >
    <span class="custom-label" style="display: flex; align-items: center">
      <img 
        :src="country.flag" 
        alt="flag" 
        style="width: 20px; height: 15px; margin-right: 8px; vertical-align: middle" 
      />
      <span style="margin-right: 8px">{{ country.country_code }}</span>
      {{ country.name }}
    </span>
  </el-option>
</el-select>

                      </template>
                    </el-input>

                    <!-- Validation Error Messages -->
                    <div class="error" v-if="showErrorOnEmpty && !mobile">Field is required</div>
                    <div class="error" v-if="showErrorOnEmpty && !isValidMobileNumber">Mobile number must be {{ getMaxLength() }} digits for the selected country.</div>
                    <div style="color: red; font-size: 0.75em" v-if="mobile.length && showErrorOnEmpty && mo_no_validation">Mobile number must contain valid numbers only.</div>
                  </div>
                  <div class="font-06rem cursor-pointer text-left top-margin-10" style="color: #000">
                    <span style="color: #000; font-weight: 500">Note:</span>
                    Enter your
                    <span style="color: green">WhatsApp Number</span>
                    for further communication
                  </div>
                </div>
              </div>

              <div class="top-margin-15" v-if="is_otp_sent">
                <div class="input-group-section">
                  <div
                    class="form-group"
                    :class="{
                      'not-empty': otp.length,
                      'form-group--error': showErrorOnEmpty && $v.otp.$error,
                    }"
                  >
                    <!-- <label class="input-label block bottom-margin-5"
                      >ENTER OTP</label
                    > -->

                    <div class="text-left">
                      <div class="bottom-margin-5 label-lg">One Time Mobile Verification</div>
                      <label class="input-label block bottom-margin-20">Enter Otp</label>
                    </div>

                    <el-input type="text" class="form-control" name="otp" v-model="otp" @input="setOtp($event)" size="small"></el-input>
                  </div>
                  <div class="error" v-if="showErrorOnEmpty && !$v.otp.required">Field is required</div>
                </div>
              </div>

              <div class="text-center">
                <el-button rounded class="btn-secondary-theme-filled" style="width: 150px" v-on:click="is_otp_sent ? verifyOtp() : generateOtp()" :loading="is_verify_otp_btn_loading">{{ is_otp_sent ? 'VERIFY OTP' : 'GENERATE OTP' }}</el-button>
              </div>
            </div>

            <div class="text-center top-margin-5" v-if="is_otp_sent">
              <span style="color: #000; font-size: 0.9rem; font-weight: 300; border-bottom: 1px solid #000; cursor: pointer" @click="regenerateOtp()">Regenerate OTP</span>
            </div>

            <div v-if="is_otp_sent" class="text-center top-margin-10 font-weight-500 font-07rem">
              <span>
                Mobile Number: {{ mobile }}
                <br />
              </span>
              Entered the wrong number?
              <span
                style="color: #4488d0; text-decoration: underline; cursor: pointer"
                @click="
                  mobile = '';
                  is_otp_sent = false;
                "
              >
                Click here to update.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import { loginNetworkCallBack } from '../mixins/login.NetworkCallback';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import CripNotice from 'crip-vue-notice';
import { DeviceInfoCallBack } from '../mixins/DeviceInfo';

export default {
  name: 'OtpVerification',

  mixins: [loginNetworkCallBack, DeviceInfoCallBack],
  props: ['deviceData'],

  data() {
    return {
      is_otp_sent: false,
      is_resend_otp: false,
      mobile: '',
      full_name: '',
      otp: '',
      showErrorOnEmpty: false,
      is_verify_otp_btn_loading: false,
      is_resend_otp_btn_loading: false,
      deviceInfo: {},
      mo_no_validation: false,

      nav_title: 'Mobile Verification',
      logo1: require('../assets/images/logo/logo1.png'),
      otpImage: require('../assets/images/MobileVerification/OTP Image.svg'),
      currentEnvironment: localStorage.getItem('currentEnvironment') ? JSON.parse(localStorage.getItem('currentEnvironment')) : {},
      isValidMobileNumber: true,
      selectedCountryCode: '+91',
      countryCodes: [
        {
          name: 'India',
          country_code: '+91',
          flag: require('@/assets/images/Country-flags/India.svg'),
          length: 10,
        },
        {
          name: 'Singapore',
          country_code: '+65',
          flag: require('@/assets/images/Country-flags/Singapore.svg'),
          length: 8,
        },
        {
          name: 'United States',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/United States.svg'),
          length: 10,
        },
        {
          name: 'Canada',
          country_code: '+1',
          flag: require('@/assets/images/Country-flags/Canada.svg'),
          length: 10,
        },
        {
          name: 'Dubai',
          country_code: '+971',
          flag: require('@/assets/images/Country-flags/Dubai.svg'),
          length: 9,
        },
        {
          name: 'Saudi Arabia',
          country_code: '+966',
          flag: require('@/assets/images/Country-flags/Saudi Arabia.svg'),
          length: 9,
        },
        {
          name: 'Oman',
          country_code: '+968',
          flag: require('@/assets/images/Country-flags/Oman.svg'),
          length: 8,
        },
        {
          name: 'United Kingdom',
          country_code: '+44',
          flag: require('@/assets/images/Country-flags/United Kingdom.svg'),
          length: 10,
        },
        {
          name: 'Australia',
          country_code: '+61',
          flag: require('@/assets/images/Country-flags/Australia.svg'),
          length: 9,
        },
      ],
    };
  },

  validations: {
    full_name: {
      required,
    },
    otp: {
      required,
    },
    mobile: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
  },

  beforeRouteEnter(to, from, next) {
    let userProfile = JSON.parse(localStorage.getItem('profile'));

    let currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

    if (userProfile) {
      return next({ name: 'expertsPastRecommendations' });
    }

    if (!currentEnvironment || (currentEnvironment && !currentEnvironment.byPassLogin)) {
      return next({ name: 'login' });
    }

    let websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    if (websiteUserType && websiteUserType.userType == 'stockAnts') {
      return next({ name: 'login' });
    }

    next();
  },

  async mounted() {
    try {
      this.deviceInfo = await this.getUniqueDeviceInfo();
      // this.authBypassLogin();
    } catch (error) {
      console.error('Error fetching device info:', error);
    }
  },

  methods: {
    // Get the max length for the selected country code
    getMaxLength() {
      const selectedCountry = this.countryCodes.find((country) => country.country_code === this.selectedCountryCode);
      return selectedCountry ? selectedCountry.length : 10; // Default to 10 if country not found
    },
    // Validate the mobile number length
    validateMobileNumber() {
      const maxLength = this.getMaxLength();
      this.isValidMobileNumber = this.mobile.length === maxLength;
    },

    setFullName(value) {
      this.full_name = value;
      this.$v.full_name.$touch();
    },
    setOtp(value) {
      this.otp = value;
      this.$v.otp.$touch();
    },

    setMobile(value) {
      this.show_error_on_empty = true;

      if (value) {
        this.mobile = value.trim();
        this.$v.mobile.$touch();
        var numbers = /^[0-9]+$/;
        if (this.mobile.match(numbers)) {
          this.mo_no_validation = false;
        } else {
          this.mo_no_validation = true;
        }
      }
    },

    async generateOtp() {
      this.otp = '';
      this.$v.mobile.$touch();
      this.$v.full_name.$touch();

      if (this.$v.mobile.$invalid || this.$v.full_name.$invalid || this.mo_no_validation) {
        this.showErrorOnEmpty = true;
        return;
      }

      if (this.mobile.trim().length && !this.mo_no_validation) {
        this.is_verify_otp_btn_loading = true;
        try {
          const response = await serverAddr.post('/auth/v1/generate_mobile_otp', {
            country_code: this.selectedCountryCode,
            mobile: this.mobile,
            // full_name:this.full_name,
            purpose: 'SIGN_UP',
          });
          if (response.status) {
            this.is_otp_sent = true;
            new CripNotice({
              title: 'Success',
              description: response.data.validation,
              type: 'success',
              duration: 3,
            });
          }
        } catch (error) {
          console.error('Error generating OTP:', error);
          new CripNotice({
            title: 'Error',
            description: 'Please enter valid OTP',
            type: 'error',
            duration: 3,
          });
        } finally {
          this.is_verify_otp_btn_loading = false;
        }
      }
    },

    async verifyOtp() {
      this.showErrorOnEmpty = true;
      this.$v.$touch();
      if (this.otp.trim().length) {
        this.is_verify_otp_btn_loading = true;
        try {
          const response = await serverAddr.post('/auth/v1/create_account_using_mobile_number', {
            country_code: this.selectedCountryCode,
            mobile: this.mobile,
            mobile_otp: Number(this.otp),
            full_name: this.full_name,
            purpose: 'SIGN_UP',
            device_info: this.deviceInfo,
          });
          this.verifyOtpNetworkCallBack(response);
          // Add logic for successful OTP verification
        } catch (error) {
          console.error('Error verifying OTP:', error);
          new CripNotice({
            title: 'Error',
            description: 'Please enter valid OTP',
            type: 'error',
            duration: 3,
          });
        } finally {
          this.is_verify_otp_btn_loading = false;
        }
      }
    },

    async regenerateOtp() {
      this.showErrorOnEmpty = false;
      this.$v.otp.$reset(); // Reset OTP validation state
      await this.generateOtp();
    },
  },
  computed: {
  selectedCountry() {
    return this.countryCodes.find(country => country.country_code === this.selectedCountryCode) || null;
  }
},
};
</script>
<style lang="scss" scoped>
@import '../css/common.scss';
@import '../css/variable.scss';

.OtpVerification {
  height: 100%;
  overflow: hidden;

  .MobileVerification {
    // background-color: $page-background-color;
    width: 100%;
    height: 100%;

    .mobile-verification-inner {
      height: 100vh;
      align-items: flex-start;
    }

    .head-section {
      position: absolute;
      text-align: left;

      .main-head {
        font-size: 3rem;
        color: #ffff;
        font-weight: 700;
        padding: 5px 30px;
      }

      .second-head {
        font-size: 1.2rem;
        color: #ffff;
        font-weight: 500;
        padding: 5px 30px;
      }
    }
  }

  .image-column {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    /* Prevents overflow */
  }

  .left-image {
    width: 63%;
    background-image: url('../assets/images/MobileVerification/Background\ Image\ \(MOB\).svg');
    height: 100%;
    /* Ensure it takes the full height */
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    padding-top: 35px;
    text-align: center;

    .full-image {
      width: 90%;
      height: 70%;
      margin-top: 20%;
      margin-right:auto;
      margin-left:auto;
    }
  }

  .right-content {
    width: 37%;
    text-align: center;
    padding: 50px;

    .powered-by-txt {
      text-align: left;
      font-weight: 600;
      position: relative;
      left: 10px;
      font-size: 12px;
    }

    .center-line {
      border: 1px solid dimgrey;
      height: 45px;
      align-self: center;
    }

    .label-lg {
      font-size: 1.1rem;
      font-weight: 700;
    }

    .input-box-section {
      padding: 10px 50px;
    }

    .btn-secondary-theme-filled {
      font-size: 0.7rem;
      margin-top: 25px;
      border-radius: 4px;
      padding: 10px;
    }
  }

  .content-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .logos {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo {
    width: 190px;
    height: auto;
  }

  .otp-image-container {
    margin-bottom: 20px;
    margin-top: 30px;
  }

  .otp-image {
    max-width: 100%;
    height: auto;
  }

  .otp-form {
    width: 100%;
  }

  .background-image {
    background-image: url('../assets/images/login/mobilebg.png');
    height: 100vh;
    width: 100%;
    background-position: center 0px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    opacity: 1;
  }

  // .bg-inner {
  //   background: #0808088a;
  //   width: 100%;
  //   height: 100%;
  // }
  .box-card {
    border-radius: 10px;
    margin: 0.4rem;
  }

  .login-card-position {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 450px;
  }

  .input-group-section {
    margin-bottom: 16px;
  }

  @media screen and (max-width: 1150px) {
    .MobileVerification .head-section {
      top: 65px;

      .main-head {
        font-size: 2.6rem;
      }

      .second-head {
        font-size: 1rem;
      }
    }
  }

  @media screen and (max-width: 1000px) {
    .MobileVerification .head-section {
      .main-head {
        font-size: 2rem;
      }

      .second-head {
        font-size: 0.6rem;
      }
    }

    .right-content .input-box-section {
      padding: 10px 20px;
    }

    .right-content {
      padding: 50px 10px;
    }
  }

  @media screen and (max-width: 800px) {
    overflow: auto !important;

    .MobileVerification .mobile-verification-inner {
      flex-direction: column;
    }

    .MobileVerification .head-section {
      position: unset;
      text-align: center;

      .main-head {
        font-size: 1.5rem;
        padding: 5px 10px;
      }

      .second-head {
        font-size: 0.6rem;
        padding: 5px 10px;
      }
    }

    .left-image {
      width: 100%;
      height: auto;
      overflow: visible;
      text-align: center;

      .full-image {
        width: 50%;
        position: relative;
        top: -50px;
      }
    }

    .right-content {
      width: 450px;
      padding: 50px 0;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 450px) {
    .login-card-position {
      width: 100%;
    }

    .left-image .full-image {
      width: 330px;
    }

    .otp-image-container {
      margin-bottom: 0px;
      margin-top: 0px;
    }

    .right-content {
      width: 100%;
      padding: 30px 0;
      border-radius: 12px;
      position: relative;
      top: -8px;
      background: #ffff;

      .btn-secondary-theme-filled {
        margin-top: 10px;
      }

      .input-box-section {
        padding: 0px 20px;
        margin-top: -7px !important;
      }

      .center-line {
        height: 30px;
        align-self: auto;
      }

      .label-lg {
        font-size: 0.9rem;
      }

      .input-label {
        font-size: 10px;
        margin-bottom: 10px;
      }
    }

    .input-group-section {
      margin-bottom: 10px;
    }

    .logo {
      width: 130px;
      height: 38px;
      padding: 0 10px;
    }

    .logos {
      justify-content: center;
      margin-bottom: 10px;
    }

    .otp-image {
      width: 60px;
    }
  }
}
</style>

<style lang="scss">
@import '../css/common.scss';
@import '../css/variable.scss';

.OtpVerification {
  .input-group-section {
    .el-input__inner::placeholder {
      color: #878787;
      /* Replace #999 with your desired placeholder color */
    }

    .el-input-group__prepend {
      background-color: #f4f4f4;
      color: #000000;
      font-weight: 600;
      border: 1px solid #dcdfe6;
      border-right: none;
    }
  }

  .right-content {
    .el-input__inner {
      background: #f4f4f4;
    }

    .form-control ::placeholder {
      color: #878787;
      /* Change to desired color */
    }
  }
}

.OtpVerification .el-button.is-loading:before {
  background-color: $primary-theme-color;
  position: relative;
}

.OtpVerification .el-button .el-icon-loading {
  font-weight: bold;
}
</style>
